<template>
  <div class="container choose-packages">
    <p class="little-title">{{ $t('serviceUpgrade') }}</p>

    <div class="content text-center">
      <!-- <p class="describe-text">{{ $t('instructions') }}</p>
      <p class="package-type-btn-box">
        <span @mouseOver="setCurrentType('vip')" @click="setCurrentType('vip')" :class="[{'current-type': currentType === 'vip'}]">VIP</span>
        <span
          @mouseOver="setCurrentType('svip')"
          @click="setCurrentType('svip')"
          :class="[{'current-type': currentType === 'svip'}]"
          v-if="svipPackages.length > 0"
        >SVIP</span>
      </p> -->
      <p class="describe">{{ $t('vipAdvantage') }}</p>
      <p :class="['device-btn', { 'change-margin': buyTip }]">
        <span>{{ $t('numberOfDevices') }}</span>
        <button
          @mouseover="chooseDevice(item)"
          v-for="item in devices"
          :key="item"
          :class="[{ 'choose-device': item === currentDevice }, 'line-button']"
        >
          {{ item }}
          <!-- <template v-if="buyTip">
            <span class="triangle"></span>
            <span class="title">{{ buyTip }}</span>
          </template> -->
        </button>
      </p>

      <div class="buy-tip" v-if="buyTip">{{ buyTip }}</div>

      <div :class="['col-' + currentCol + '-box', 'all-packages', 'packages-list-box']">
        <template v-for="(item,index) in packages">
          <packageItem
            :item="item"
            :key="'pkg' + index"
            :currentPackage="currentPackage"
            @mouseover.native="choosePackage(item, 'mouseover')"
            @click-button="choosePackage(item, 'click')"
            @show-tip="showBuyTip"
            @blur.native="showBuyError = false"
          ></packageItem>
        </template>
      </div>

      <div class="declaration">
        <span>{{ $t('declaration') }}</span>
        <p v-for="(item, index) in $t('declarationList')" :key="index" class="declaration-list">
          <span class="index">{{ index + 1 }}</span>
          {{ item }}
        </p>
      </div>
    </div>

    <created-subscription></created-subscription>
    <subscribe-result></subscribe-result>

    <pay-order></pay-order>
    <pay-redirect></pay-redirect>
    <creating-order></creating-order>
    <created-order></created-order>
    <top-up-result></top-up-result>

    <div class="modal fade" id="subscription" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div :class="['modal-dialog', {'zh-style': language === 'zh'}]" role="document">
        <div class="modal-content">
          <modal-header></modal-header>
          <div class="modal-body" v-if="subscriptionInfo">
            <h3>{{ $t('cancelSubscriptionTitle') }}</h3>
            <p class="subscription-package">{{ $t('subscriptionPackage') }}{{ subscriptionInfo.package_name }}</p>
            <p class="payment-info">{{ $t('paymentMethod') }}{{ subscriptionInfo.payment_method }}</p>

            <template v-if="['iTunes', 'Google Play'].includes(subscriptionInfo.payment_method)">
              <button @click="hideModal">{{ $t('back') }}</button>
              <div v-if="subscriptionInfo.payment_method === 'iTunes'">{{ $t('itunesTip') }}</div>
              <div v-else>{{ $t('googleTip') }}</div>
            </template>
            
            <template v-else>
              <button v-if="!show.cancelling" @click="cancelSubscription" class="cancel">{{ $t('cancelSubscription') }}</button>
              <spinner-component :show="show.cancelling" class="spinner-component"></spinner-component>
              <div v-if="cancelError" class="cancel-error">{{ cancelError }}</div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import { addImpression } from '../../../assets/js/ecommerceAnalytics';
import { getKeyCount } from '../../../lib/arrayHandle';
import { browerName } from '../../../lib/browerName';
import { mapState } from 'vuex';
import locales from './lang';
import GradientBtn from '../../../components/gradientBtn/GradientBtn.vue';

import PayRedirect from '../../topup/payRedirect/PayRedirect.vue';
import CreatingOrder from '../../creatingOrder/CreatingOrder.vue';
import CreatedSubscription from '../../subscription/createdSubscription/CreatedSubscription.vue';
import SubscribeResult from '../../subscription/subscribeResult/SubscribeResult.vue';
import PayOrder from '../../payOrder/Index.vue';
import CreatedOrder from '../../createdOrder/CreatedOrder.vue';
import TopUpResult from '../../topup/topUpResult/TopUpResult.vue';
import { isMobile, isAndroid, isIOS, isMac, isWindows } from '../../../lib/fun';
import CountDown from '../../../views/home/choosePackage/countDown.vue';
import packageItem from '../../packageItem/packageItemNew.vue';
import ModalHeader from '../../modalHeader/ModalHeader.vue'
import SpinnerComponent from '../../../components/Spinner.vue'

function getSortUniqueDevices(packages) {
  let devices = packages.map(function (pkg) {
    return pkg.device_count;
  });
  devices.sort(function (a, b) {
    return a - b;
  });
  return _.sortedUniq(devices);
}

export default {
  name: 'choosePackage',
  components: {
    GradientBtn,
    PayOrder,
    PayRedirect,
    CreatingOrder,
    CreatedOrder,
    TopUpResult,
    CreatedSubscription,
    SubscribeResult,
    CountDown,
    packageItem,
    ModalHeader,
    SpinnerComponent
  },
  data: function () {
    return {
      devices: '',
      currentDevice: '',
      currentPackage: '',
      packageCol: '',
      packageSort: 0,
      browerName: browerName(),
      showBuyError: false,
      vipPackages: [],
      svipPackages: [],
      currentType: '',
      buyTip: '',
      subscriptionInfo: null,
      show: {
        cancelling: false
      },
      cancelError: '',
      cancelSubscriptionSuccess: false
    };
  },
  locales,
  computed: {
    currentCol() {
      return this.packageCol[this.currentDevice];
    },
    maxCol() {
      if (this.mediaType === 'pc') {
        return 4;
      } else if (this.mediaType === 'pad') {
        return 3;
      } else return 1;
    },
    packages() {
      if (this.currentType === 'svip') {
        return this.svipPackages;
      } else {
        return this.vipPackages;
      }
    },
    ...mapState({
      user: state => state.user,
      currentSymbol: state => state.currentSymbol,
      mediaType: state => state.mediaType,
      updatePackageInfo: state => state.topup.updatePackageInfo,
      clickIndexPagePackageData: state => state.clickIndexPagePackageData
    }),
    getMaxDeviceNum() {
      return this.$store.state.user.max_device_count;
    },
    language() {
      return this.$store.state.currentLang;
    }
  },
  created() {
    this.getSubscription()
  },
  watch: {
    getMaxDeviceNum() {
      const deviceCount = this.getDefaultDeviceCount();
      if (!deviceCount) return;
      this.currentDevice = deviceCount;
      this.currentPackage = this.getCurrentPackage(deviceCount);
    },
    updatePackageInfo(val) {
      if (val) {
        this.getSubscription()
      }
    },
    currentDevice() {
      this.packageSort = 0;
      this.packageCol = this.getPackageCol();
    },
    packages(val) {
      this.addImpressionAnalytics(this.packages);
      this.devices = getSortUniqueDevices(this.packages);
      this.packageCol = this.getPackageCol();
      if (this.cancelSubscriptionSuccess) {
        this.cancelSubscriptionSuccess = false
        this.currentPackage = val.filter(p => p.id === this.currentPackage.id)[0]
        this.show.cancelling = false
        this.choosePackage(this.currentPackage, 'click')
        setTimeout(() => {
          this.subscriptionInfo = null
          $('#subscription').hide()
          $('.modal-backdrop:eq(0)').remove()
        }, 500)
      } else {
        this.currentDevice = this.getDefaultDeviceCount();
        this.currentPackage = this.getCurrentPackage(this.currentDevice);
        this.choosePackage(this.currentPackage);
        this.$store.commit('setCurrentPackage', this.currentPackage);
      }
    },
    buyTip(val) {
      if (val) {
        this.positionDeviceBtns()
      }
    }
  },
  methods: {
    positionDeviceBtns() {
      let _btnTop = $('.choose-packages .device-btn').offset().top
      let headerH = screen.width > 911 ? 80 : 60
      let scrollH = _btnTop - headerH
      $(window).scrollTop(scrollH)
    },
    getSubscription() {
      new Promise((resolve, reject) => {
        this.$store.dispatch('getSubscription').then(response => {
          if (response.body.code === 0) {
            let resData = response.body.data
            if (resData.status === 'active') {
              this.subscriptionInfo = {
                subscription_id: resData.subscription_id,
                payment_method: resData.payment_method_name,
                package_name: resData.package_detail.name
              }
            }
          }
          resolve()
        }, error => {
          reject(error)
        })
      }).then(res => {
        this.loadPackages()
      }).catch(err => {
        console.warn(err)
      })
    },
    hideModal() {
      $('#subscription').modal('hide')
    },
    cancelSubscription() {
      this.show.cancelling = true
      this.cancelError = ''
      this.$http.post('api/topup-subscription/cancel?web=1', {
        subscription_id: this.subscriptionInfo.subscription_id,
        cancel_reason: ''
      }).then((response) => {
        if (response.data.code === 0) {
          this.cancelSubscriptionSuccess = true
          this.getSubscription()
        } else {
          this.show.cancelling = false
          this.cancelError = response.body.message
        }
      })
    },
    showBuyTip(tip) {
      this.$nextTick(() => {
        let userExpired = this.user.value_of_expire_in === 0
        if (this.subscriptionInfo && (userExpired || (!userExpired && this.currentDevice >= this.user.max_device_count))) {
          $('#subscription').modal('show')
          this.show.cancelling = false
          this.cancelError = ''
        } else {
          this.buyTip = tip
          setTimeout(() => {
            this.buyTip = ''
          }, 2000);
        }
      })
    },
    setSubscriptionInfo(val) {
      this.subscriptionInfo = val
      $('#subscription').modal('show')
      this.show.cancelling = false
      this.cancelError = ''
    },
    // get eventName
    gtmEvent(eventName, pageCategory, name, currencySymbol, price, deviceCount) {
      if (isMobile()) {
        if (isAndroid()) {
          eventName = 'Android_H5_' + eventName;
        } else if (isIOS()) {
          eventName = 'iOS_H5_' + eventName;
        } else {
          eventName = 'other_H5_' + eventName;
        }
      } else {
        if (isMac()) {
          eventName = 'Mac_PC_' + eventName;
        } else if (isWindows()) {
          eventName = 'Windows_PC_' + eventName;
        } else {
          eventName = 'other_PC_' + eventName;
        }
      }

      // Event snippet for topUp page
      window.dataLayer &&
        window.dataLayer.push({
          event: eventName,
          pageCategory: pageCategory,
          Products: [
            {
              name: name,
              currencySymbol: currencySymbol,
              price: price,
              deviceCount: deviceCount
            }
          ]
        });
    },
    hiddenCover() {
      this.showCover = false;
      this.showBuyError = false;
    },
    hiddenErrorNotice() {
      this.showBuyError = false;
    },
    canNotBuy(currentPackage) {
      if (this.mediaType !== 'pc' || this.browerName === 'Safari') {
        this.showCover = true;
      }
      this.showBuyError = true;
      this.currentPackage = currentPackage;
      this.$store.commit('setCurrentPackage', currentPackage);
    },
    loadPackages() {
      this.$http
        .get('api/v2/topup-packages', {
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
        .then(response => {
          this.packagesClassification(response.body.data);
          if (this.user.role === 'svip') {
            this.setCurrentType('svip');
          } else {
            this.setCurrentType('vip');
          }
          window.sessionStorage.removeItem('needUseNoCache');
        });
    },
    packagesClassification(allPackages) {
      this.vipPackages = [];
      this.svipPackages = [];
      for (let pkg of allPackages) {
        if (pkg.type === 'svip') {
          if (pkg.is_recommended) {
            this.svipPackages.unshift(pkg);
          } else {
            this.svipPackages.push(pkg);
          }
        } else {
          if (pkg.is_recommended) {
            this.vipPackages.unshift(pkg);
          } else {
            this.vipPackages.push(pkg);
          }
        }
      }
      this.$store.commit('setUpdatePackageInfo', false);
      
      this.$nextTick(() => {
        if(localStorage.getItem('isActivityPackage') !== null) {
          this.positionDeviceBtns()
          localStorage.removeItem('isActivityPackage')
        }
        
        let clickIndexPagePackageData = null;
        if (localStorage.clickIndexPagePackageData) clickIndexPagePackageData = JSON.parse(localStorage.clickIndexPagePackageData);
        if (this.clickIndexPagePackageData) clickIndexPagePackageData = this.clickIndexPagePackageData;
        if (clickIndexPagePackageData) {
          this.positionDeviceBtns()

          this.currentDevice = parseInt(localStorage.getItem('currentDevice'))
          setTimeout(() => {
            localStorage.removeItem('currentDevice')
          }, 500)
          let currentDevicePackages = this.packages.filter(p => p.device_count === this.currentDevice)
          currentDevicePackages.map(item => {
            if (item.id === clickIndexPagePackageData.id) {
              if (!item.can_topup && !item.can_subscribe) {
                this.showBuyTip(item.disabled_reason)
                this.choosePackage(item);
              } else {
                this.choosePackage(item, 'click');
              }
              this.$store.commit('setClickIndexPagePackageData', null);
              delete localStorage.clickIndexPagePackageData;
            }
          });
        }
      });
    },
    setCurrentType(type) {
      this.currentType = type;
    },
    chooseDevice(deviceNum) {
      this.buyTip = ''
      this.currentDevice = deviceNum;
      this.addImpressionAnalytics();
      this.currentPackage = this.getCurrentPackage(deviceNum);
      this.showBuyError = false;
      this.$store.commit('setCurrentPackage', this.currentPackage);
    },
    choosePackage(currentPackage, eventType) {
      this.showBuyError = false;
      this.currentPackage = currentPackage;
      if (eventType === 'click') {
        // Event snippet for topUp page
        this.gtmEvent(
          'top_up',
          'top_up',
          currentPackage.name,
          currentPackage.currency_symbol,
          currentPackage.price,
          currentPackage.device_count
        );
        $('#pay-order').modal('show');
      }
      this.$store.commit('setCurrentPackage', currentPackage);
    },
    chooseH5Package(item) {
      if (!item.can_topup && !item.can_subscribe) {
        if (window.innerWidth < 769) {
          this.$toast(item.disabled_reason);
        } else {
          this.canNotBuy(item);
        }
      } else {
        $('#pay-order').modal('show');
      }
    },
    getCurrentPackage(deviceNum) {
      let defaultPackage = null;
      for (let pkg of this.packages) {
        if (!defaultPackage && pkg.device_count === deviceNum) {
          defaultPackage = pkg;
        }
        if (pkg.device_count === deviceNum && pkg.is_recommended) {
          return pkg;
        }
      }
      return defaultPackage || {};
    },
    getPackageCol() {
      let allDevices = this.packages
        .map(function (pkg) {
          return pkg.device_count;
        })
        .sort();
      let packageCol = {};
      this.devices &&
        this.devices.map(function (device) {
          let deviceShowCount = getKeyCount(device, allDevices);
          packageCol[device] = deviceShowCount;
        });
      return packageCol;
    },
    addImpressionAnalytics() {
      for (let pkg of this.packages) {
        if (pkg.device_count === this.currentDevice && pkg.id > 0) {
          let monthsUnit = this.months(pkg) > 1 ? 'Months' : 'Month';
          let pkgName = this.months(pkg) + ' ' + monthsUnit;

          let deviceUnit = pkg.device_count > 1 ? 'Devices' : 'Device';
          let deviceName = pkg.device_count + ' ' + deviceUnit;

          let packageName = pkgName + '/' + deviceName;

          let pkgTotalPrice = pkg.is_update ? (pkg.price + pkg.price_for_upgrade).toFixed(2) : pkg.price;
          addImpression({
            id: pkg.id,
            name: packageName,
            price: pkgTotalPrice,
            list: 'PlexVPN',
            currency: this.currentSymbol,
            deviceCount: pkg.device_count
          });
        }
      }
    },
    months(pkg) {
      if (pkg.frequency === 'year') {
        return pkg.frequency_interval * 12;
      } else {
        return pkg.frequency_interval;
      }
    },
    getPackageName(name) {
      return name.split('（')[0] || '';
    },
    getDefaultDeviceCount() {
      if (this.devices.includes(this.user.max_device_count)) {
        return this.user.max_device_count;
      } else {
        for (let i of this.devices) {
          if (i > this.user.max_device_count) {
            return i;
          }
        }
      }
      return this.devices[0];
    }
  },
  filters: {
    getDiscount(pkg) {
      if (pkg.list_price) {
        return (100 - (pkg.price / pkg.list_price) * 100).toFixed(0) + '%';
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../../assets/scss/reset-modal";
@import './choosePackage';
// @import '../../../views/home/choosePackage/choosePackage.scss';

@media screen and (max-width: 769px) {
  .container .content {
    padding: 0 .16rem;
  }
}

.packages-list-box .package {
  &:nth-child(5n) {
    margin-right: 0;
  }
  @media screen and (max-width: 769px) {
    width: 100%;
  }
}

#subscription {
  .modal-dialog {
    @include modal-dialog($height: 3.46rem, $phone-height: 3.66rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 1.83rem) 0 0 -45% !important;
    }
    &.zh-style {
      @include modal-dialog($height: 3.2rem, $phone-height: 3.4rem);
      @media (max-width: 767px) {
        margin: calc(50vh - 1.7rem) 0 0 -45% !important;
      }
    }

    .modal-content {
      text-align: center;
      .modal-body {
        margin-top: 0.24rem;
        color: #333;
        h3 {
          font-size: .2rem;
          font-weight: 600;
          line-height: .26rem;
          padding-bottom: .1rem;
        }
        p {
          margin-top: .18rem;
          font-size: .16rem;
          &.payment-info, &.subscription-package {
            text-align: left;
            padding-left: 20%;
          }
        }
        .spinner-component {
          margin: .4rem auto 0;
        }
        button {
          margin-top: .4rem;
          width: 70%;
          height: .4rem;
          line-height: .4rem;
          border-radius: 20px;
          font-size: .16rem;
          color: #fff;
          background: #999;
          &.cancel {
            background: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
          }
        }
        div {
          margin-top: .1rem;
          font-size: .14rem;
          &.cancel-error {
            color: #F15A66;
          }
        }
        @media (max-width: 767px) {
          margin-top: 0.2rem;
          p {
            &.payment-info, &.subscription-package {
              padding-left: 10%;
            }
          }
          button {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ChoosePackage.vue?f1ef9ec2